import {
    ExpertCertificate,
    AttestationCommissions,
    ExpertDetails,
    ExamList,
} from '../../api/ApiClient';
import { createModel } from '@rematch/core';
import moment from 'moment';
import apiConnector from '../../api/ApiConnector';
import { IPayloadExpertExams } from 'components/models';

const initialState: IState = {
    certificateList: null,
    acList: null,
    personalData: null,
    examsList: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setCertificateList(state, certificateList: ExpertCertificate | null) {
            return { ...state, certificateList };
        },
        setAcsList(state, acList: AttestationCommissions | null) {
            return { ...state, acList };
        },
        clearState() {
            return {
                ...initialState,
            };
        },
        setPersonalData(state, personalData: ExpertDetails | null): IState {
            return { ...state, personalData };
        },
        setExamsList(state, examsList: ExamList | null) {
            return { ...state, examsList };
        },
    },
    effects: (dispatch: any) => ({
        /* Certificate */
        async getCertificateListAsync() {
            // const certificateList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpertCertificates());
            //
            // this.setCertificateList(certificateList);
        },
        async getPersonalDataAsync(expertId: string) {
            this.setPersonalData(null);

            const personalData = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpert(expertId));

            this.setPersonalData(personalData);
        },
        async addCertificateAsync({ certificateData }: IAddCertificateProps) {
            const certificateList = await apiConnector.execApi(dispatch, apiClient => apiClient.addExpertCertificateFix(
                certificateData.regNumber,
                certificateData.issueDate,
                certificateData.expireDate,
                certificateData.file || new File([], ''),
            ));

            if (certificateList) {
                this.setCertificateList(certificateList);
                dispatch.notifications.addNotification([{ message: 'Сертификат успешно добавлен!', level: 'success' }]);
            }

            return certificateList;
        },
        async deleteCertificateAsync({ certificateId }: IDeleteCertificateProps) {
            const certificateList = await apiConnector.execApi(dispatch, apiClient => apiClient.removeExpertCertificate(certificateId));

            this.setCertificateList(certificateList);
            if (certificateList) {
                dispatch.notifications.addNotification([{ message: 'Сертификат успешно удален!', level: 'success' }]);
            }
        },
        async updateCertificateAsync({ certificateId, certificateData }: IUpdateCertificateProps) {
            const certificateList = await apiConnector.execApi(dispatch, apiClient => apiClient
                .updateExpertCertificateFix(certificateId, certificateData.regNumber, certificateData.issueDate, certificateData.expireDate, certificateData.file));

            if (certificateList) {
                this.setCertificateList(certificateList);
                dispatch.notifications.addNotification([{ message: 'Сертификат успешно обновлен!', level: 'success' }]);
            }

            return certificateList;
        },
        async getAttestationCommissionsAsync({
            searchField, searchTerm, page, pageSize, sortOrder, sortField,
        }: IGetAttestationCommissionsListProps) {
            const acList = await apiConnector.execApi(dispatch, apiClient => apiClient.getAttestationCommissions(undefined, undefined, searchField, searchTerm, page, pageSize, sortOrder, sortField));

            this.setAcsList(acList);
        },
        /* Clear state */
        clearExpertState() {
            this.clearState();
        },
        async getExamsListAsync(payload: IPayloadExpertExams) {
            const examsList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpertExams(
              payload.expertId,
              payload.qualificationIds,
              payload.attestationSubCommissionIds,
              payload.accreditationCenterIds,
              payload.filteredExamStatus,
              payload.from,
              payload.to,
              payload.page,
              payload.pageSize,
              payload.sortOrder,
              payload.sortField,
            ));

            this.setExamsList(examsList);
        },
    }),
});

export interface IUpdateCertificateProps {
    certificateId: string;
    certificateData: ICertificate;
}

export interface IAddCertificateProps {
    certificateData: ICertificate;
}

interface IGetAttestationCommissionsListProps {
    expertId?: string;
    searchField?: string;
    searchTerm?: string;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
}

interface ICertificate {
    regNumber: string;
    issueDate: moment.Moment;
    expireDate: moment.Moment;
    file?: File;
}

interface IDeleteCertificateProps {
    certificateId: string;
}

interface IState {
    personalData: ExpertDetails | null;
    certificateList: ExpertCertificate[] | null;
    acList: AttestationCommissions | null;
    examsList: ExamList | null;
}
